/* Adds the bonus-kit gifts alongside the main product when a bundle tier is chosen.
   Only runs when the block's "Add gifts to cart automatically" setting is on.

   The gifts are added in the SAME /cart/add.js call as the main product, so the cart
   can never end up holding gifts without the item that earned them. Because that
   bypasses the theme's own submit handler, the cart drawer is refreshed afterwards,
   falling back to a /cart navigation if no drawer is present. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.qbcBound === '1') return;
    if (root.dataset.giftsToCart !== 'true') return;

    var variants = (root.dataset.giftVariants || '')
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(Boolean);
    if (!variants.length) return;

    var form = root.closest('form[action*="/cart/add"]');
    if (!form) {
      var id = root.querySelector('.qbc__input[form]');
      if (id) form = document.getElementById(id.getAttribute('form'));
    }
    if (!form) return;

    root.dataset.qbcBound = '1';

    form.addEventListener('submit', function (event) {
      var checked = root.querySelector('.qbc__input:checked');
      if (!checked) return;
      var card = checked.nextElementSibling;
      var count = card ? parseInt(card.dataset.giftCount || '0', 10) : 0;
      if (!count) return;

      var mainId = form.querySelector('[name="id"]');
      if (!mainId || !mainId.value) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var items = [{ id: Number(mainId.value), quantity: Number(checked.value) || 1 }];
      variants.slice(0, count).forEach(function (v) {
        items.push({ id: Number(v), quantity: 1 });
      });

      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-disabled', 'true');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description || 'add failed');
          refreshCart();
        })
        .catch(function (err) {
          console.error('[quantity-breaks-cards] gift add failed:', err);
          window.location = window.Shopify.routes.root + 'cart';
        })
        .finally(function () {
          if (button) button.removeAttribute('aria-disabled');
        });
    }, true);
  }

  function refreshCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      try { drawer.open(); return; } catch (e) { /* fall through to reload */ }
    }
    window.location = window.Shopify.routes.root + 'cart';
  }

  function boot() {
    document.querySelectorAll('.qbc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
